import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import('@/views/home'),
      meta: {
        title: '校招云聘 - 找工作，更简单',
        description: '校招云聘官网，专注校园招聘，连接优秀学子与优质企业。'
      }
    },
    {
      path: "/job-search",
      name: "job-search",
      component: () => import('@/views/job-search'),
      meta: {
        title: '职位搜索 - 校招云聘',
        description: '搜索最新职位，找到心仪工作。'
      }
    },
    {
      path: "/job-detail",
      name: "job-detail",
      component: () => import('@/views/job-detail'),
      meta: {
        title: '职位详情 - 校招云聘',
        description: '查看职位详细信息，了解公司福利待遇。'
      }
    },
    {
      path: "/companies",
      name: "companies",
      component: () => import('@/views/companies'),
      meta: {
        title: '企业列表 - 校招云聘',
        description: '浏览优质企业，发现更多机会。'
      }
    },
    {
      path: "/company-detail",
      name: "company-detail",
      component: () => import('@/views/company-detail'),
      meta: {
        title: '企业详情 - 校招云聘',
        description: '查看企业详细信息，了解公司文化和福利。'
      }
    },
    {
      path: "/campus-recruitment",
      name: "campus-recruitment",
      component: () => import('@/views/campus-recruitment'),
      meta: {
        title: '校园招聘 - 校招云聘',
        description: '为应届毕业生提供优质的校园招聘机会。'
      }
    },
    {
      path: "/campus-recruitment-detail",
      name: "campus-recruitment-detail",
      component: () => import('@/views/campus-recruitment-detail'),
      meta: {
        title: '宣讲会详情 - 校招云聘',
        description: '查看宣讲会详细信息，了解宣讲会流程和职位信息。'
      }
    },
    {
      path: "/career-guidance",
      name: "career-guidance",
      component: () => import('@/views/career-guidance'),
      meta: {
        title: '求职攻略 - 校招云聘',
        description: '为求职者提供专业的求职指导和面试技巧。'
      }
    },
    {
      path: "/career-guidance-detail",
      name: "career-guidance-detail",
      component: () => import('@/views/career-guidance-detail'),
      meta: {
        title: '攻略详情 - 校招云聘',
        description: '查看求职攻略的详细内容。'
      }
    },
    {
      path: "/auth",
      name: "auth",
      component: () => import('@/views/auth'),
      meta: {
        title: '登录/注册 - 校招云聘',
        description: '登录或注册校招云聘账号。'
      }
    },
    {
      path: "/register",
      name: "register",
      component: () => import('@/views/register'),
      meta: {
        title: '注册账号 - 校招云聘',
        description: '注册校招云聘账号，开启求职之旅。'
      }
    },
    {
      path: "/user-center",
      name: "user-center",
      component: () => import('@/views/user-center'),
      meta: {
        title: '个人中心 - 校招云聘',
        description: '管理个人信息、简历、投递记录等。'
      }
    },
    {
      path: "/resume",
      name: "resume",
      component: () => import('@/views/resume'),
      meta: {
        title: '我的简历 - 校招云聘',
        description: '管理个人简历，完善求职信息。'
      }
    },
    {
      path: "/feedback",
      name: "feedback",
      component: () => import('@/views/feedback'),
      meta: {
        title: '投递反馈 - 校招云聘',
        description: '查看简历投递状态和企业反馈。'
      }
    },
    {
      path: "/creator",
      name: "creator",
      component: () => import('@/views/creator'),
      meta: {
        title: '创作者中心 - 校招云聘',
        description: '分享求职经验，帮助更多求职者。'
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import('@/views/settings'),
      meta: {
        title: '账号设置 - 校招云聘',
        description: '管理账号安全和隐私设置。'
      }
    },
    {
      path: "/about",
      name: "about",
      component: () => import('@/views/about'),
      meta: {
        title: '关于我们 - 校招云聘',
        description: '了解校招云聘的公司简介、使命和价值观。'
      }
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import('@/views/contact'),
      meta: {
        title: '联系我们 - 校招云聘',
        description: '联系校招云聘，获取帮助和支持。'
      }
    },
    {
      path: "/user-agreement",
      name: "userAgreement",
      component: () => import('@/views/UserAgreement'),
      meta: {
        title: '用户协议 - 校招云聘',
        description: '联系校招云聘，获取帮助和支持。'
      }
    },
    {
      path: "/privacy-policy",
      name: "privacyPolicy",
      component: () => import('@/views/PrivacyPolicy'),
      meta: {
        title: '隐私政策 - 校招云聘',
        description: '联系校招云聘，获取帮助和支持。'
      }
    },
    {
      path: "/forgot-password",
      name: "forgotPassword",
      component: () => import('@/views/ForgotPassword'),
      meta: {
        title: '忘记密码 - 校招云聘',
        description: '联系校招云聘，获取帮助和支持。'
      }
    },
    {
      path: "/ai-match",
      name: "ai-match",
      component: () => import('@/views/ai-match'),
      meta: {
        title: '智能匹配 - 校招云聘',
        description: '联系校招云聘，获取帮助和支持。'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})




// WEBPACK FOOTER //
// ./src/router/index.js